import React from "react";
import { Layout } from "react-admin";
import MyAppBar from "./MyAppBar";
import MySidebar from "./MySidebar";

const MyLayout = (props) => <Layout {...props} sidebar={MySidebar} appBar={MyAppBar} />;

export default MyLayout;
